/** Бэкенд отвечает UserInputError("REQUEST_ALREADY_OPEN"). */
export function isRequestAlreadyOpen(error: unknown): boolean {
  const e = error as {
    message?: string;
    graphQLErrors?: { message?: string; extensions?: { code?: unknown } }[];
  };
  return Boolean(
    e?.graphQLErrors?.some(
      (g) =>
        g.message === "REQUEST_ALREADY_OPEN" ||
        g.extensions?.code === "REQUEST_ALREADY_OPEN",
    ),
  );
}
